import { Service, computed, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClientCompanyDataService } from '@data-services/companies';
import { Company } from '@models/companies';
import { DataContext } from '@services/data-context';
import { createPageResource } from '@utils';

@Service({ autoProvided: false })
export class CompanyService {
  private readonly clientCompanyDataService = inject(ClientCompanyDataService);
  private readonly dataContext = inject(DataContext);
  private readonly translate = inject(TranslateService);

  readonly resource = createPageResource<Company | undefined, string>({
    params: () => this.dataContext.companyContext()?.id,
    loadAsync: (companyId) => this.clientCompanyDataService.getCompanyByIdAsync(companyId),
    errorMessage: () => this.translate.instant('general.loadNamedCompanyError', { name: this.dataContext.companyContext()?.companyName() ?? '' }),
    fallbackValue: undefined
  });

  readonly currentSprintIds = computed(() => this.resource.value()?.CurrentSprintIds ?? []);
}
